import React, {useEffect, useState, useCallback} from 'react';
import api from "../../api";
import {Button, Col, Pagination, Row, Segmented} from "antd";
import './style.css';
import UpdateCard from "../../Components/UpdateCard";
import LogUpdateModal from "../../Components/LogUpdateModal";
import {useTranslations} from "../../lang";
import SubscribersModal from "../../Components/SubscribersModal";
import {useNavigate} from "react-router-dom";

export default function Updates() {

    const [feedData, setFeedData] = useState({items: [], total: 0, page: 1, page_size: 12});
    const [view, setView] = useState('feed');
    const [page, setPage] = useState(1);
    const [createUpdateModalOpen, setCreateUpdateModalOpen] = useState(false);
    const {translate} = useTranslations();
    const navigate = useNavigate();
    const isLoggedIn = api.isLoggedIn();

    const loadFeed = useCallback((p, mine) => {
        api.getUpdatesFeed(p, 12, mine).then(setFeedData);
    }, []);

    useEffect(() => {
        loadFeed(page, view === 'mine');
    }, [view, page, loadFeed]);

    const deleteUpdate = (update) => {
        api.deleteUpdate(update.id).then(() => {
            loadFeed(page, true);
        });
    }

    const onViewChange = (val) => {
        setView(val);
        setPage(1);
    }

    const onPageChange = (p) => {
        setPage(p);
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <div>
            <LogUpdateModal open={createUpdateModalOpen} onCancel={() => {
                setCreateUpdateModalOpen(false);
                loadFeed(page, view === 'mine');
            }}/>
            <Row>
                <Col xs={24} md={12}>
                    <h1>{translate('Updates')}</h1>
                    {view === 'feed' && <p>{translate('Bekijk de laatste updates van alle tuinders.')}</p>}
                    {view === 'mine' && <p>{translate('Hier vind je alle updates die op je profiel staan.')}</p>}
                </Col>
                <Col xs={24} md={12} className={"text-right"}>
                    {isLoggedIn && (
                        <Segmented
                            value={view}
                            onChange={onViewChange}
                            options={[
                                {label: translate('Alle updates'), value: 'feed'},
                                {label: translate('Mijn updates'), value: 'mine'},
                            ]}
                            className={"mar-r-1"}
                        />
                    )}
                    {isLoggedIn && (
                        <>
                            <SubscribersModal/>
                            <Button type={"primary"} size="large" onClick={() => setCreateUpdateModalOpen(true)}>
                                {translate('Nieuwe update posten')}
                            </Button>
                        </>
                    )}
                </Col>
            </Row>

            <Row gutter={12}>
                {feedData.items.map(update => (
                    <Col xs={24} sm={6} key={`update${update.id}`}>
                        <UpdateCard update={update} children={
                            view === 'mine' ? (
                                <Button size={"small"} danger className={"mar-b-1"}
                                        onClick={() => deleteUpdate(update)}>
                                    {translate('Verwijderen')}
                                </Button>
                            ) : (
                                update.company && update.company.slug && (
                                    <Button size={"small"} className={"mar-b-1"}
                                            onClick={() => navigate(`/${update.company.slug}`)}>
                                        {update.company.name}
                                    </Button>
                                )
                            )
                        }/>
                    </Col>
                ))}
            </Row>

            {feedData.total > feedData.page_size && (
                <Row className={"mar-t-1"}>
                    <Col xs={24} className={"text-center"}>
                        <Pagination
                            current={feedData.page}
                            total={feedData.total}
                            pageSize={feedData.page_size}
                            onChange={onPageChange}
                        />
                    </Col>
                </Row>
            )}
        </div>
    );
}
